import React, { useContext, useEffect, useState } from 'react';
import { Form, Modal, message, Input } from "antd";
import { useAtom ,useAtomValue} from "jotai";
import DetalleEnvioService from "services/DetalleEnvioService";
import { UploadOutlined  } from "@ant-design/icons";
import {
    consultaDocumentoSeleccionadoAtom,
    visibleModalRechazarDocumentoAtom,
    documentosAtom
  } from "../../ConsultaDocumentoStore";
import { OnboardingColaboradorService } from 'services/OnboardingColaboradorService';

const ModalRechazarDocumento = () => {
    const [formRechazo] = Form.useForm();
    const { TextArea } = Input;
    const [visible,setVisible] = useAtom(visibleModalRechazarDocumentoAtom);
    const documentoSeleccionado = useAtomValue(consultaDocumentoSeleccionadoAtom);
    const [documentos, setDocumentos] = useAtom(documentosAtom);
    
    const [loading,setLoading] = useState(false);    
   
    const onFinishRechazo = async(formulario) => {
        setLoading(true);
        try {
            formulario.detalleId = documentoSeleccionado.id;
            const _ = await OnboardingColaboradorService.rechazar(formulario);

            // Actualizar el estado del documento en la lista
              const documentosActualizados = {
                  ...documentos,
                  data: documentos.data.map(doc => 
                      doc.id === documentoSeleccionado.id 
                          ? { 
                              ...doc, 
                              estadoFirmaColaborador: "PENDIENTE",
                              estadoAprobacion: "RECHAZADO"
                          }
                          : doc
                  )
              };
              setDocumentos(documentosActualizados);

            message.success("El documento ha sido rechazado.");
            setVisible(false);
            formRechazo.resetFields();

        } catch (error) {
          console.log("error:", error);
            message.error("Error al rechazar el documento.");
        } finally {
            setLoading(false);
        }
    }


    return(
        <Modal
          title="Rechazar Documento"
          open={visible}
          onCancel={() => setVisible(false)}
          onOk={() => formRechazo.submit()}
          confirmLoading={loading}
          destroyOnClose={true}
        >
          <Form
            layout="vertical"
            form={formRechazo}
            onFinish={onFinishRechazo}>
                <Form.Item 
                    label="Indica el motivo del rechazo"
                    name={"motivoRechazo"}>
                    <TextArea showCount maxLength={160} style={{ height: 120 }} autoSize={false} />
                    </Form.Item>
                    <Form.Item 
                    name={"detalleId"}
                    hidden>
                    <Input />
                </Form.Item>
              
            </Form>
           
           
        </Modal>
    )
};

export default ModalRechazarDocumento;